module.exports = __webpack_public_path__ + "img/accesscourses.d0804157.svg";